import { BoxServiceInstance } from "./box.serviceInstance";

export class EventListenerServiceInstance extends BoxServiceInstance {
}